function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import VerticalTimerTabsDefaultProps from "segments/desktop/core-components/vertical-timer-tabs/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
const getAsset = (videoName)=>({
        video: {
            loop: false,
            src: {
                formats: [
                    `/static/video/capabilites_videos/${videoName}.mp4`
                ]
            }
        }
    });
export default _object_spread_props(_object_spread({}, VerticalTimerTabsDefaultProps), {
    tabs: [
        {
            title: "1. Collaborate",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("flexibility")
        },
        {
            title: "2. Connect",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("insight")
        },
        {
            title: "3. Execute",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("data-viz")
        }
    ],
    backgroundColor: "transparent",
    progressbarColor: "dodger-blue",
    showArrow: true,
    assetPosition: positionTypes.CENTER_CENTER,
    showButton: false,
    buttonConfig: {},
    alwaysShowProgressbar: true,
    title: {
        fontColor: "silver",
        selectedFontColor: "dodger-blue",
        fontSize: "40px",
        selectedFontSize: "40px",
        fontWeight: "bold"
    }
});
